async function downloadFileFromStream(stream) {
    try {
        const data = await stream.arrayBuffer();
        var base64Str = Buffer.from(data).toString('base64');
        var binaryString = window.atob(base64Str);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        var arrBuffer = bytes;
        var newBlob = new Blob([arrBuffer], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
        }
        const pdfdata = window.URL.createObjectURL(newBlob);
        window.open(pdfdata, '_blank');
    } catch (error) {
        throw new Error("could not trigger download for file the stream.")
    }
}

export default downloadFileFromStream